import LegalDocumentSection from '@/components/sections/legal/LegalDocumentSection'
import LegalHeroSection from '@/components/sections/legal/LegalHeroSection'
import { useData } from '@/hooks/useLocale'
import { useTitle } from '@/hooks/useTitle'

/** Privacy, terms and cookies: one layout, fed the document at `path` in the current language. */
export default function LegalPage({ path }) {
  const { LEGAL_DOCS } = useData()
  const doc = LEGAL_DOCS.find((d) => d.path === path)
  useTitle(doc.title)

  return (
    <>
      <LegalHeroSection doc={doc} />
      <LegalDocumentSection doc={doc} />
    </>
  )
}
